import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "pl-3 font-bold text-xl" }, "People Behind the Scenes", -1)
const _hoisted_2 = { class: "shadow-base rounded-3xl w-[20rem] my-2 mx-2" }
const _hoisted_3 = { class: "font-bold flex text-left pl-10 mt-2" }
const _hoisted_4 = { class: "font-normal text-sm opacity-70 text-left pl-10 pb-10" }

import { IonSlides, IonSlide } from "@ionic/vue"

  interface Details {
    image: string
    name: string
    position: string
    bio: string
    worksona?: string
  }

  interface Props {
    peopleData: Details[]
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'PeopleContainer',
  props: {
    peopleData: null
  },
  setup(__props: any) {

const props = __props as {
    peopleData: Details[]
  }

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_unref(IonSlides), null, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.peopleData, (people) => {
          return (_openBlock(), _createBlock(_unref(IonSlide), {
            key: `${people}_id`
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", {
                  class: "bg-light-gray-100 bg-cover bg-no-repeat bg-top flex items-end justify-end h-[250px] rounded-t-3xl",
                  style: _normalizeStyle({ 'background-image': `url(${people.image})` })
                }, null, 4),
                _createElementVNode("span", _hoisted_3, _toDisplayString(people.name), 1),
                _createElementVNode("p", _hoisted_4, _toDisplayString(people.position), 1)
              ])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})